<template>
    <!--    图片添加修改-->
    <div class="imageBox" v-loading="showLoading">
        <el-form ref="form" :model="font" label-width="120px">
            <el-form-item label="文件名" >
                <!-- 有本地字体（新选或已下载）才随改名重画；否则不画，避免空白预览 -->
                <el-input v-model="font.name" class="input" @input="onNameInput"></el-input>
            </el-form-item>
            <el-form-item label="是否支持英文" v-if="!isTemplateInto">
                <el-select v-model="font.supportEs" placeholder="请选择是否支持英文">
                    <el-option
                            v-for="item in selectSupportEs"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否是VIP可用" v-if="!isTemplateInto">
                <el-select v-model="font.isVip" placeholder="请选择是否是VIP可用">
                    <el-option
                            v-for="item in selectVips"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
          <el-form-item label="字体预览:" v-show="isShowFontPreview">
            <div class="font_preview">
              <canvas id="myCanvas"></canvas>
            </div>
          </el-form-item>
          <el-form-item label="字体预览:" v-show="!isShowFontPreview && isUpdate">
            <div class="font_preview">
              <img :src="font.previewImageUrl">
            </div>
          </el-form-item>
          <!-- 仅编辑需要：添加时用户会直接选字体文件，不走下载 -->
          <el-form-item label="生成预览" v-if="isUpdate">
            <el-button
                v-if="!localFontForPreview"
                size="small"
                type="warning"
                :loading="previewLoading"
                @click="downloadFontAndGenPreview">
              下载字体并生成预览
            </el-button>
            <!-- 已有本地字体（下过或新传过）：只刷新画布，不再下载 -->
            <el-button
                v-else
                size="small"
                type="success"
                @click="refreshPreview">
              刷新预览
            </el-button>
            <el-button
                v-if="localFontForPreview"
                size="small"
                :loading="previewLoading"
                @click="downloadFontAndGenPreview">
              重新下载
            </el-button>
            <div class="el-upload__tip">
              未用本地字体生成预览前，保存不会改预览图；已下载后改名可点「刷新预览」
            </div>
          </el-form-item>
            <el-form-item label="上传文件">
                <el-upload
                        class="upload-demo"
                        action="none"
                        :file-list="font.fileList"
                        :on-exceed="imageCountOut"
                        :on-remove="handleRemove"
                        :on-change="fileChange"
                        :auto-upload="false"
                        :limit="1">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传一个文件，且不超过50MB</div>
                </el-upload>
            </el-form-item>
            <!-- 手动上传 7z：后端写入 zip_url，目录与原字体相同 release/font/ -->
            <el-form-item label="压缩文件(7z)">
                <el-upload
                        class="upload-demo"
                        action="none"
                        accept=".7z"
                        :file-list="font.zipFileList"
                        :on-exceed="imageCountOut"
                        :on-remove="handleZipRemove"
                        :on-change="zipFileChange"
                        :auto-upload="false"
                        :limit="1">
                    <el-button size="small" type="primary">上传7z</el-button>
                    <div slot="tip" class="el-upload__tip">可选，自行压缩后的 .7z 文件</div>
                </el-upload>
            </el-form-item>
            <el-form-item class="btn">
                <el-button type="primary" @click="save">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "FontEdit",
        props: ['font',"isUpdate","isTemplateInto"],
        data:function () {
            return{
                showLoading:false,
                previewLoading:false,
                fontName:"",
                selectSupportEs:[
                    {
                        label:"不支持英文",
                        value:0
                    },{
                        label:"支持英文",
                        value:1
                    }
                ],
                selectVips:[
                    {
                        label:"不是VIP",
                        value:0
                    },
                    {
                        label:"VIP可用",
                        value:1
                    },
                ],
                isShowFontPreview:false,
                fontImagePreview:null,//字体预览文件
                // 本地已有可用于画预览的字体 File（下载得到 或 用户新选）；未就绪则保存不传预览
                localFontForPreview:null,
                // 已成功用本地字体生成过预览，才允许把 previewFile 提交后端
                previewGenerated:false
            }
        },
        watch: {
            // 打开编辑：先显示旧预览图，清空本地字体/生成标记，避免误传空白预览
            "font.id": function () {
                if (this.isUpdate && this.font) {
                    this.resetPreviewState()
                }
            }
        },
        methods:{
            resetPreviewState: function () {
                this.isShowFontPreview = false
                this.localFontForPreview = null
                this.previewGenerated = false
                this.fontImagePreview = null
                if (this.font) {
                    this.font.file = null
                }
            },
            imageCountOut: function () {
                this.showErrorMessage("只能选择一个文件")
            },
            /**
             * 图片移除回调
             * @param file
             * @param fileList
             */
            handleRemove: function (file, fileList) {
               this.font.file = null
               this.localFontForPreview = null
               this.previewGenerated = false
               this.isShowFontPreview = false
            },
            handleZipRemove: function () {
               this.font.zipFile = null
            },
            /**
             * 图片选择回调
             * @param file
             * @param fileList
             */
            fileChange: function (file, fileList) {
                this.font.file = file.raw
                this.localFontForPreview = file.raw
                // 上传字体后，名称默认用文件名（去掉后缀），之后可再手动改
                const rawName = (file.raw && file.raw.name) ? file.raw.name : (file.name || "")
                if (rawName) {
                    const dot = rawName.lastIndexOf(".")
                    this.font.name = dot > 0 ? rawName.substring(0, dot) : rawName
                }
                this.isShowFontPreview = true
                this.drawFontPreview()
                // 添加：选文件即生成；编辑：新传字体也算已生成，可刷新
                this.previewGenerated = true
            },
            // 7z 压缩包选择（可选，写入后端 zip_url）
            zipFileChange: function (file) {
                this.font.zipFile = file.raw
            },
            onNameInput: function () {
                // 添加：选了文件后改名实时画；编辑：没有本地字体不画
                if (!this.localFontForPreview && !this.font.file) {
                    return
                }
                // 编辑且尚未拿到本地字体时，不画空白
                if (this.isUpdate && !this.localFontForPreview) {
                    return
                }
                this.drawFontPreview()
                if (this.isUpdate && this.localFontForPreview) {
                    this.previewGenerated = true
                }
            },
            // 已有本地字体时：只重画预览，不重新下载
            refreshPreview: function () {
                if (!this.localFontForPreview) {
                    this.showErrorMessage("请先下载字体或重新上传字体文件")
                    return
                }
                this.drawFontPreview()
                this.previewGenerated = true
            },
            /**
             * 编辑用：经后端同源接口代理下载字体（CDN 直接 fetch 会跨域），再画预览。
             * 不写 font.file，避免保存时误把原字体再上传一遍。
             */
            downloadFontAndGenPreview: function () {
                if (!this.isUpdate) {
                    return
                }
                if (!this.font || !this.font.id) {
                    this.showErrorMessage("字体 id 无效")
                    return
                }
                this.previewLoading = true
                const that = this
                let token = ""
                try {
                    const storageData = localStorage.getItem(process.env.VUE_APP_USER_KEY)
                    if (storageData) {
                        const parsed = JSON.parse(storageData)
                        const userInfo = parsed && parsed.userInfo ? parsed.userInfo : parsed
                        token = (userInfo && userInfo.token) ? userInfo.token : ""
                    }
                } catch (e) {
                    token = ""
                }
                // 不用页面 fetch(CDN)：会跨域；走后端 /font/downloadFontFile
                axios.get(process.env.VUE_APP_HOST + "/font/downloadFontFile", {
                    params: { id: this.font.id },
                    headers: { token: token },
                    responseType: "blob",
                    timeout: 120000
                }).then(function (res) {
                    const blob = res.data
                    if (!blob || blob.size === 0) {
                        throw new Error("empty blob")
                    }
                    // 若后端返回的是 JSON 错误，blob.type 常为 application/json
                    if (blob.type && blob.type.indexOf("json") !== -1) {
                        throw new Error("server json error")
                    }
                    const fileName = (that.font.name || "font") + ".ttf"
                    const file = new File([blob], fileName, {type: blob.type || "application/octet-stream"})
                    that.localFontForPreview = file
                    that.isShowFontPreview = true
                    that.drawFontPreview()
                    that.previewGenerated = true
                    that.previewLoading = false
                }).catch(function (err) {
                    that.previewLoading = false
                    that.previewGenerated = false
                    console.error("下载字体生成预览失败", err)
                    that.showErrorMessage("下载字体失败，请稍后重试或手动重新上传字体文件后再改预览")
                })
            },
            /**
             * 显示错误信息弹框
             * @param msg 错误信息弹框
             */
            showErrorMessage: function (msg) {
                this.$confirm(msg, "提示", {
                    confirmButtonText: '确定',
                    showClose: false,
                    showCancelButton: false,
                    center: true,
                    type: 'error'
                })
            },
            cancel: function () {
                this.$emit('saveStatus', false)
            },
            /**
             * 保存上传
             * */
            save() {
                if (!this.isUpdate){
                    this.addFont()
                }else {
                     this.updateFont()
                }
            },
            addFont:function () {
                if (this.font.name === undefined || this.font.name === ""){
                    this.showErrorMessage("请输入字体名称")
                    return
                }
                if (this.font.supportEs === undefined && !this.isTemplateInto) {
                    this.showErrorMessage("请选择字体是否支持英文")
                    return
                }
                if (this.font.isVip === undefined && !this.isTemplateInto){
                    this.showErrorMessage("请选择字体是否是VIP可用" )
                    return
                }
                if (this.font.file === undefined || this.font.file == null){
                    this.showErrorMessage("请选择一个字体文件")
                    return
                }
                this.fontImagePreview = this.dataURLtoFile();
                this.showLoading = true;
                const that = this;
                const params = new FormData()
                params.append("file", this.font.file)
                params.append("previewFile", this.fontImagePreview)
                params.append("fontName", this.font.name)
                // 可选：手动选的 7z，后端存到与原字体同目录并写 zip_url
                if (this.font.zipFile) {
                  params.append("zipFile", this.font.zipFile)
                }

                if (this.isTemplateInto === true){
                  // params.append("isTemplateFont", "0")
                  params.append("supportEs", "1")
                  params.append("isVip","0")
                }else {
                  params.append("supportEs", this.font.supportEs)
                  params.append("isVip", this.font.isVip)
                }
                this.$request.post("/font/addFont", params, { timeout: 180000 })
                    .then(function (data) {
                        that.showLoading = false
                        if (data.status === 200) {
                            that.$confirm("添加成功", "提示", {
                                confirmButtonText: '确定',
                                showClose: false,
                                showCancelButton: false,
                                center: true,
                                type: 'success'
                            }).then(function () {
                                that.$emit('saveStatus', true)
                            })
                        } else {
                            that.showErrorMessage(data.message)
                        }
                    }).catch(function (err) {
                        that.showLoading = false
                        // 字体+预览+7z 上传较慢，超时常见；服务端可能已成功，刷新列表确认
                        const msg = (err && String(err).indexOf("timeout") !== -1)
                            ? "请求超时，请刷新列表确认是否已添加成功"
                            : "网络错误"
                        that.showErrorMessage(msg)
                })
            },
            updateFont:function () {
                if (this.font.name === undefined || this.font.name === ""){
                    this.showErrorMessage("请输入字体名称")
                    return
                }
                if (this.font.supportEs === undefined) {
                    this.showErrorMessage("请选择字体是否支持英文")
                    return
                }
                if (this.font.isVip === undefined){
                    this.showErrorMessage("请选择字体是否是VIP可用")
                    return
                }

                this.showLoading = true;
                const that = this;
                const params = new FormData()
                // 只有用户重新上传了字体文件，才替换后端字体
                if (this.font.file !== undefined && this.font.file != null){
                    params.append("file", this.font.file)
                }
                // 只有「下载并生成」或「重新上传字体」成功生成过预览，才传 previewFile
                if (this.previewGenerated && this.localFontForPreview) {
                    this.fontImagePreview = this.dataURLtoFile();
                    if (this.fontImagePreview) {
                      params.append("previewFile", this.fontImagePreview)
                    }
                }
                // 编辑时可选替换/补传 7z
                if (this.font.zipFile) {
                  params.append("zipFile", this.font.zipFile)
                }
                params.append("id", this.font.id)
                params.append("fontName", this.font.name)
                params.append("supportEs", this.font.supportEs)
                params.append("isVip", this.font.isVip)
                this.$request.post("/font/updateFont", params, { timeout: 180000 })
                    .then(function (data) {
                        that.showLoading = false
                        if (data.status === 200) {
                            that.$confirm("修改成功", "提示", {
                                confirmButtonText: '确定',
                                showClose: false,
                                showCancelButton: false,
                                center: true,
                                type: 'success'
                            }).then(function () {
                                that.$emit('saveStatus', true)
                            })
                        } else {
                            that.showErrorMessage(data.data)
                        }
                    }).catch(function (err) {
                    that.showLoading = false
                    const msg = (err && String(err).indexOf("timeout") !== -1)
                        ? "请求超时，请刷新列表确认是否已修改成功"
                        : "网络错误"
                    that.showErrorMessage(msg)
                })
            },
            /**
             * 用本地字体文件画预览（必须有 localFontForPreview，否则不画）
             */
            drawFontPreview:function (){
              const selectedFile = this.localFontForPreview || this.font.file;
              if (!selectedFile) {
                return
              }
              let url = null;
              let binaryData = [];
              binaryData.push(selectedFile);
              if (window.createObjcectURL !== undefined) {
                url =  window.URL.createObjectURL(new Blob(binaryData));
              } else if (window.URL !== undefined) {
                url =  window.URL.createObjectURL(new Blob(binaryData));
              } else if (window.webkitURL !== undefined) {
                url =  window.URL.createObjectURL(new Blob(binaryData));
              }
              this.isShowFontPreview = true
              //添加样式文件
              this.addCSS('@font-face { font-family:"fontPreview";src: url("'+url+'"); ')
              //延时绘制，等待字体加载
              const that = this
              setTimeout(function (){
                const canvas = document.querySelector('#myCanvas')
                if (!canvas) {
                  return
                }
                canvas.width=100;
                canvas.height=40;
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0,100, 50);
                ctx.font = '25px fontPreview';
                ctx.fillStyle='#000000';
                ctx.textAlign = "center";
                ctx.textBaseline="middle"
                if (that.font.name === undefined || that.font.name === ""){
                  ctx.fillText("文字",50,20,100);
                }else {
                  ctx.fillText(that.font.name,50,20,100);
                }
              },200)
            },
          /**
           * 添加字体的样式
           * @param cssText
           */
          addCSS:function addCSS(cssText){
            const style = document.createElement('style'),  //创建一个style元素
                head = document.head || document.getElementsByTagName('head')[0]; //获取head元素
            style.id = "fontPreview"
            style.type = 'text/css'; //这里必须显示设置style元素的type属性为text/css，否则在ie中不起作用
            if(style.styleSheet){ //IE
              var func = function(){
                try{ //防止IE中stylesheet数量超过限制而发生错误
                  style.styleSheet.cssText = cssText;
                }catch(e){

                }
              }
              //如果当前styleSheet还不能用，则放到异步中则行
              if(style.styleSheet.disabled){
                setTimeout(func,10);
              }else{
                func();
              }
            }else{ //w3c
              //w3c浏览器中只要创建文本节点插入到style元素中就行了
              var textNode = document.createTextNode(cssText);
              style.appendChild(textNode);
              //移除之前添加的元素
              const node = document.getElementById("fontPreview")
              if (node != null){
                node.remove()
              }
            }
            head.appendChild(style); //把创建的style元素插入到head中
          },
          // 将canvas转换成file对象
          dataURLtoFile (filename = 'file') {
            const canvas = document.querySelector('#myCanvas')
            if (!canvas) {
              return null
            }
            const  dataurl = canvas.toDataURL('image/png')
            let arr = dataurl.split(',')
            let mime = arr[0].match(/:(.*?);/)[1]
            let suffix = mime.split('/')[1]
            let bstr = atob(arr[1])
            let n = bstr.length
            let u8arr = new Uint8Array(n)
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], `${filename}.${suffix}`, {type: mime})
          }
        },
    }
</script>

<style scoped>
    .imageBox {
        width: 100%;
        min-height: 300px;
    }
    .btn /deep/ .el-form-item__content {
        margin-left: 0 !important;
        text-align: center;
    }
    .input{
        width: 300px;
    }
    .font_preview{
      width: 200px;
      height: 40px;
      font-family: fontPreview;
    }
    .font_preview canvas,.font_preview img{
      width: 100px;
      height: 40px;
    }
</style>
